<script lang="ts" setup>
import {computed, onMounted, ref} from "vue";
import Image from "@src/components/ui/message-types/Image.vue";
import Document from "@src/components/ui/message-types/Document.vue";
import Audio from "@src/components/ui/message-types/Audio.vue";
import Video from "@src/components/ui/message-types/Video.vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import Comment from "@src/types/Comment";

const props = defineProps(['message']);
const sessionStore = useChatSessionStore()
const comment = ref<Comment>({
    message: '',
    files: []
})

function getComponent(type: string) {
    switch (type) {
        case 'image':
            return Image;
        case 'video':
            return Video;
        case 'audio':
            return Audio;
        default:
            return Document;
    }
}

function getExtension(url: string): string {
    return url.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
}

interface FileItem {
    url: string
    ext: string
    type: 'image' | 'video' | 'audio' | 'document'
}

const files = computed<FileItem[]>(() => {
    return comment.value.files.map((url: string) => {
        const ext = getExtension(url);

        let type: FileItem['type'] = 'document';

        if (['jpg', 'jpeg', 'png'].includes(ext)) {
            type = 'image';
        } else if (ext === 'mp4') {
            type = 'video';
        } else if (ext === 'mp3') {
            type = 'audio';
        }

        return {url, ext, type};
    });
});

onMounted(() => {
    let data = JSON.parse(props.message.message)
    comment.value.message = data.text
    comment.value.files = data.files ?? []
})

const hasFiles = computed(() => {
    return files.value.some((file) => file.type === 'audio' || file.type === 'document')
})
</script>

<template>
    <div>
        <div class="text-gray-700 dark:text-gray-200">
            {{ comment.message }}
        </div>

        <div v-if="files.length"
             :class="[
                 hasFiles
                     ? 'flex flex-wrap justify-center'
                     : 'grid grid-cols-' + files.length,
                 'gap-2 mt-2'
             ]"
        >
            <component
                :is="getComponent(file.type)"
                v-for="(file, i) in files"
                :id="props.message.id"
                :key="i"
                :data="file.url"
                :is-group="sessionStore.type === 'group'"
                :pane="true"
                :preview="false"
            />
        </div>

        <div class="text-gray-500 dark:text-gray-400 text-sm mt-3">
            Comentado por {{ props.message.sender?.name || 'User' }}
            às {{
                new Date(props.message.created_at).toLocaleTimeString('pt-BR', {
                    hour: '2-digit',
                    minute: '2-digit'
                })
            }}
        </div>
    </div>
</template>

<style scoped>
</style>